import axios from 'axios/lib/axios';

const base = '/api/v1/model/';
const timeout = 30000;

const endpoints = {
  addFormSubmission: function (data) {
    return axios.post(`${base}formSubmission`, data, {
      timeout: timeout,
    });
  },
  addDismissedViewIndicator: function (data = null) {
    return axios.post(`${base}dismissedViewIndicator`, data, {
      timeout: timeout,
    });
  },
  addContactUs: function (data) {
    return axios.post(`${base}contactUs`, data, {
      timeout: timeout,
    });
  },
  addApplication: function (data) {
    return axios.post(`${base}application`, data, {
      timeout: timeout,
    });
  },
};

export default endpoints;
